export const documentStatusConfig = {
	// Document status configuration for GR6 Land Development Work Permit
	GR6_1BalconyOrPorch: {
		['IA-63']: {
			planImplantationArpenteurGrandeEmpriseInput: 'optional',
			planImplantationFaitMainInput: 'required',
			planArchitecturePreliminaireInput: 'required',
			planAmenagementInput: 'optional',
			planAmenagementPaysagerPreliminaireInput: 'optional',
			ficheBatimentInput: 'optional',
			// planArchitectureInput: 'not_required',
			// certificatDeLocalisationInput: 'not_required',
			// planStructureInput: 'not_required',
			autresSiRequisInput: 'optional'
		},
		['PA-5']: {
			// planImplantationArpenteurGrandeEmpriseInput: 'not_required',
			planImplantationFaitMainInput: 'required',
			// planArchitecturePreliminaireInput: 'not_required',
			// planAmenagementInput: 'not_required',
			// planAmenagementPaysagerPreliminaireInput: 'not_required',
			// ficheBatimentInput: 'not_required',
			planArchitectureInput: 'optional',
			certificatDeLocalisationInput: 'required',
			planStructureInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['PA-32']: {
			planImplantationArpenteurGrandeEmpriseInput: 'required',
			planImplantationFaitMainInput: 'required',
			// planArchitecturePreliminaireInput: 'not_required',
			// planAmenagementInput: 'not_required',
			// planAmenagementPaysagerPreliminaireInput: 'not_required',
			// ficheBatimentInput: 'not_required',
			planArchitectureInput: 'required',
			certificatDeLocalisationInput: 'required',
			// planStructureInput: 'not_required',
			autresSiRequisInput: 'optional'
		},
		['PA-19']: {
			// planImplantationArpenteurGrandeEmpriseInput: 'not_required',
			planImplantationFaitMainInput: 'required',
			// planArchitecturePreliminaireInput: 'not_required',
			// planAmenagementInput: 'not_required',
			// planAmenagementPaysagerPreliminaireInput: 'not_required',
			// ficheBatimentInput: 'not_required',
			planArchitectureInput: 'required',
			certificatDeLocalisationInput: 'required',
			planStructureInput: 'optional',
			autresSiRequisInput: 'optional'
		}
	},
	GR6_2ResidentialLand: {
		['IA-62']: {
			certificatDeLocalisationInput: 'required',
			planAmenagementInput: 'required',
			planAmenagementPaysagerPreliminaireInput: 'required',
			planArchitecturePreliminaireInput: 'optional',
			etudeAcoustiqueInput: 'optional',
			engagementExemptDeContaminantInput: 'optional',
			ficheBatimentInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['CA-38']: {
			planImplantationArpenteurGrandeEmpriseInput: 'required',
			certificatDeLocalisationInput: 'required',
			autresSiRequisInput: 'optional'
		},
		['CA-13']: {
			planImplantationArpenteurGrandeEmpriseInput: 'required',
			certificatDeLocalisationInput: 'required',
			engagementExemptDeContaminantInput: 'required',
			autresSiRequisInput: 'optional'
		},
		['CA-26']: {
			planImplantationArpenteurGrandeEmpriseInput: 'required',
			certificatDeLocalisationInput: 'required',
			engagementExemptDeContaminantInput: 'required',
			autresSiRequisInput: 'optional'
		},
		['CA-12']: {
			planImplantationFaitMainInput: 'required',
			certificatDeLocalisationInput: 'required',
			planIngenieurInput: 'optional',
			planAmenagementInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['CA-6']: {
			planImplantationFaitMainInput: 'required',
			certificatDeLocalisationInput: 'required',
			planAmenagementInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['CA-24']: {
			planImplantationFaitMainInput: 'required',
			certificatDeLocalisationInput: 'required',
			planAmenagementInput: 'optional',
			planCivilInput: 'optional',
			autresSiRequisInput: 'optional'
		}
	},

	GR6_3typesOfWorkToPerformParking: {
		['IA-62']: {
			certificatDeLocalisationInput: 'required',
			planAmenagementInput: 'required',
			planAmenagementPaysagerPreliminaireInput: 'required',
			planArchitecturePreliminaireInput: 'optional',
			etudeAcoustiqueInput: 'optional',
			engagementExemptDeContaminantInput: 'optional',
			ficheBatimentInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['CA-6']: {
			planImplantationFaitMainInput: 'required',
			certificatDeLocalisationInput: 'required',
			planAmenagementInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['CA-36']: {
			certificatDeLocalisationInput: 'required',
			planImplantationFaitMainInput : 'required',
			autresSiRequisInput: 'optional'
		},
		['CA-24']: {
			planImplantationFaitMainInput: 'required',
			certificatDeLocalisationInput: 'required',
			planAmenagementInput: 'optional',
			planCivilInput: 'optional',
			autresSiRequisInput: 'optional'
		}
	},

	GR6_4TypesOfWorkBoat: {
		['CA-28']: {
			planImplantationFaitMainInput: 'required',
			certificatDeLocalisationInput: 'required',
			planArchitectureInput: 'optional',
			autresSiRequisInput: 'optional'
		}
	},
	GR6_5TypesOfWorkDiverse: {
		['IA-62']: {
			certificatDeLocalisationInput: 'required',
			planAmenagementInput: 'required',
			planAmenagementPaysagerPreliminaireInput: 'required',
			planArchitecturePreliminaireInput: 'optional',
			etudeAcoustiqueInput: 'optional',
			engagementExemptDeContaminantInput: 'optional',
			ficheBatimentInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['IA-63']: {
			planImplantationFaitMainInput: 'required',
			planArchitecturePreliminaireInput: 'required',
			planImplantationArpenteurGrandeEmpriseInput: 'optional',
			planAmenagementInput: 'optional',
			planAmenagementPaysagerPreliminaireInput: 'optional',
			ficheBatimentInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['CA-35']: {
			planImplantationFaitMainInput: 'required',
			planIngenieurInput: 'required',
			etudeAcoustiqueInput: 'required',
			certificatDeLocalisationInput: 'required',
			planAmenagementInput: 'required',
			engagementExemptDeContaminantInput: 'required',
			autresSiRequisInput: 'optional'
		},
		['PA-41']: {
			planImplantationArpenteurGrandeEmpriseInput: 'required',
			planIngenieurInput: 'required',
			autresSiRequisInput: 'optional'
		},
		['CA-24']: {
			planImplantationFaitMainInput: 'required',
			certificatDeLocalisationInput: 'required',
			planAmenagementInput: 'optional',
			planCivilInput: 'optional',
			autresSiRequisInput: 'optional'
		},
		['CA-6']: {
			planImplantationFaitMainInput: 'required',
			certificatDeLocalisationInput: 'required',
			planAmenagementInput: 'optional',
			autresSiRequisInput: 'optional'
		}
	}
}
